var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{style:({color:_vm.actionColorList[_vm.scope.text]})},[_vm._v(_vm._s(_vm.scope.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }